'use strict';

angular.module('TurneroApp').component('coAgendaPaso4', {
    bindings: {
        ctrlPadre: '='
    }, controller: [
        '$scope',
        '$timeout',
        'agendaService',
        'TurneroAppConstant',
        'utilsService',
        function ($scope, $timeout, agendaService, TurneroAppConstant, utilsService) {
            var ctrl = this;

            //se setean los valores por defecto. 
            ctrl.index = null;
            ctrl.Franjas_Alta = '';
            ctrl.Franjas_Modificacion = '';
            ctrl.CantidadTurnos = '';
            ctrl.Estados = TurneroAppConstant.Estados.Agenda;

            ctrl.limpiarMemoria = function () {
                ctrl.mostrarModificarAgregar = false;
                ctrl.Franjas_Alta = '';
                ctrl.Franjas_Modificacion = '';
                ctrl.Id_Franja_Baja = ''
                ctrl.Franja = {
                    Id_Franja: 0,
                    Hora_Desde: '',
                    Hora_Hasta: '',
                    Cant_Puestos: 0,
                    Id_Franja_Particular: 0,
                    Fecha: moment(moment().toDate().toLocaleString()).format('DD-MM-YYYY'),
                    Dias: '',
                    Modalidades: '',
                }
                ctrl.Agenda = {
                    Id_Agenda: null,
                    Id_Usuario: '',
                    Fec_Desde: '',
                    Fec_Hasta: '',
                    Duracion_Turno: 0,
                    Max_Turnos_Dias: 0,
                    Ciclos_Turnos: 0,
                    Max_Turnos_Online: 0,
                    Cant_Turnos_Persona: 0,
                    Dias_Visibilidad: 0,
                    Id_Estado: 0,
                    Franjas_Alta: '',
                    Franjas_Modificacion: '',
                    Id_Franja_Baja: '',
                    Dias: null,
                    Modalidad: null,
                    Franjas: null
                }
                ctrl.errores = {
                    Duracion_Turno: false,
                    Duracion_Turno_Ciclo: false,
                    Fec_Desde: false,
                    Fec_Hasta: false,
                    Fec_Desde_Hasta: false,
                    Ciclos_Turnos: false,
                    Max_Turnos_Dias: false,
                    Max_Turnos_Dias_x_Online: false,
                    Max_Turnos_Online: false
                }
            };

            // este metodo lo triggerea el agenda consulta, para cargar el paso 2 en la pantalla.
            $scope.$on('inicioAgendaPaso4_load', function (event, obj) {
                ctrl.limpiarMemoria();
                //del objeto que recibo, si la agenda es nueva(Pendiente) y el Id_Agenda
                ctrl.Agenda.Id_Agenda = obj.Id_Agenda;
                ctrl.agendaNueva = obj.isNew;
                if (ctrl.Agenda.Id_Agenda != null) {
                    //Si el Id_Agenda no es null, se obtiene la informacion almacenada en la base de datos para esta agenda.
                    agendaService.Get_Paso4({ 'id_agenda': ctrl.Agenda.Id_Agenda }).$promise.then(function (resultado) {
                        ctrl.Agenda = resultado.Data;
                        var fecha_de_hoy = (new Date()).toISOString();

                        ctrl.Agenda.Fec_Desde = ctrl.Agenda.Fec_Desde ? ctrl.Agenda.Fec_Desde : fecha_de_hoy;
                        ctrl.Agenda.Fec_Hasta = ctrl.Agenda.Fec_Hasta ? ctrl.Agenda.Fec_Hasta : fecha_de_hoy;
                        //se limpian los valores para los parametros de franjas alta, baja y modificacion
                        ctrl.Agenda.Franjas_Alta = '';
                        ctrl.Agenda.Id_Franja_Baja = '';
                        ctrl.Agenda.Franjas_Modificacion = '';
                        ctrl.Agenda.EsSUAC = ctrl.Agenda.Es_Agenda_Suac == 'S' ? true : false;

                        //Por unica vez cuando se carga por primera vez el paso 4
                        var primeraCarga = ctrl.Agenda.Duracion_Turno == 0 && ctrl.Agenda.Ciclos_Turnos == 0 ? true : false;
                        ctrl.Agenda.Duracion_Turno = primeraCarga ? 15 : ctrl.Agenda.Duracion_Turno;
                        ctrl.Agenda.Max_Turnos_Dias = primeraCarga ? 60 : ctrl.Agenda.Max_Turnos_Dias;
                        ctrl.Agenda.Ciclos_Turnos = primeraCarga ? 60 : ctrl.Agenda.Ciclos_Turnos;
                        ctrl.Agenda.Max_Turnos_Online = primeraCarga ? 30 : ctrl.Agenda.Max_Turnos_Online;
                        ctrl.Agenda.Cant_Turnos_Persona = primeraCarga ? 1 : ctrl.Agenda.Cant_Turnos_Persona;

                        //ctrl.total();
                        //	$scope.$destroy()
                        $timeout(function () {
                            $scope.$apply();
                        });
                        //	$scope.$apply()
                    }).catch(function (error) {
                        utilsService.errores(error);
                    })
                } else {
                    //Por unica vez cuando se carga por primera vez el paso 4
                    ctrl.Agenda.Duracion_Turno = 15
                    ctrl.Agenda.Max_Turnos_Dias = 60
                    ctrl.Agenda.Ciclos_Turnos = 60
                    ctrl.Agenda.Max_Turnos_Online = 30
                    ctrl.Agenda.Cant_Turnos_Persona = 1
                }
            });

            // cambiar de vista. sobretodo para el boton atras.- */*/funcion es una funcion que esta definida en el ctrlPadre, que se la llama en el html/*/*
            ctrl.cambiarVista = function (funcion) {
                funcion(true, ctrl.Agenda.Id_Estado == TurneroAppConstant.Estados.Agenda.Pendiente, ctrl.Agenda.Id_Agenda);
            };

            //SWITCHTAB, es la funcion que se ejecuta cuando el usuario hace click en una tab de cualquiera de los pasos. IMPORTANTE SOLO FUNCIONA PARA AGENDAS NO PENDIENTES
            //*/*/funcion es una funcion que esta definida en el ctrlPadre, que se la llama en el html/*/*
            ctrl.switchTab = function (paso, funcion) {
                var pasoActual = 1;
                if (ctrl.Agenda.Id_Estado == TurneroAppConstant.Estados.Agenda.Pendiente && pasoActual > paso) {
                    ctrl.cambiarVista(funcion);
                } else if (ctrl.Agenda.Id_Estado != TurneroAppConstant.Estados.Agenda.Pendiente) {
                    ctrl.cambiarVista(funcion);
                }
            };

            ctrl.convertirFecha = function (fecha) {

                var fecha = moment(fecha);
                return fecha.toISOString();
            }

            ctrl.cancelar = function (mostrarMensaje = false) {
                if (mostrarMensaje) {
                    ctrl.ctrlPadre.mostrarMensajeFinal();
                } else {
                    ctrl.limpiarMemoria();
                    ctrl.ctrlPadre.consultaAgendas(true);
                }
            };

            //GUARDAR CAMBIOS PASO 4
            ctrl.guardarPaso4 = function (paso_siguiente) {
                //verificamos que la agenda este abierta en readonly, si es asi, va al paso 5 sin guardar
                if (ctrl.ctrlPadre.readOnly) {
                    ctrl.ctrlPadre.inicioAgendaPaso5(true, true, ctrl.Agenda.Id_Agenda);
                } else {
                    //Sino empieza a validar los datos de la agenda.
                    swal({
                        title: 'Procesando datos.',
                        text: 'Esta operación puede demorar algunos minutos.',
                        type: 'info',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                    });
                    swal.showLoading();
                    //si la funcion retorna true es porque supero todas las validaciones.
                    if (ctrl.validarForm()) {
                        if (ctrl.Agenda.Id_Agenda != null) {
                            agendaService.Put_Agenda_Paso4(({ 'id': ctrl.Agenda.Id_Agenda }, ctrl.Agenda)).$promise.then(function (result) {
                                swal.close();

                                if (result.Data && result.Data.Tramites_Repetidos && result.Data.Tramites_Repetidos.length > 0) {
                                    swal({
                                        title: 'Trámites repetidos',
                                        html: "Uno de los trámites ya existe online para otra agenda. Presione aceptar si desea exportar el listado a excel.",
                                        type: 'info',
                                        confirmButtonColor: '#004b81',
                                        confirmButtonText: 'Aceptar',
                                        showCancelButton: true,
                                        allowEscapeKey: false,
                                        allowOutsideClick: false,
                                        cancelButtonColor: '#971b2f',
                                        cancelButtonText: 'Cancelar'
                                    }).then(function (respuesta) {
                                        if (respuesta === true) {
                                            exportarExcel(result.Data.Tramites_Repetidos);
                                        }
                                    })
                                } else if (result.Data && result.Data.CalendarioNoExiste) {
                                    swal({
                                        title: 'Atención',
                                        text: 'El Calendario Nacional de feriados no se encuentra cargado para la fecha de vigencia seleccionada.',
                                        type: 'info',
                                        confirmButtonColor: '#004b81',
                                        allowEscapeKey: false,
                                        allowOutsideClick: false,
                                        confirmButtonText: 'Aceptar'
                                    }).then(function () {
                                        ctrl.controlarTurnosAfectados(result, paso_siguiente);
                                    });
                                } else {
                                    ctrl.controlarTurnosAfectados(result, paso_siguiente);
                                }
                            }).catch(function (error) {
                                utilsService.errores(error, null);
                            })
                        } else {
                            swal.close();
                        }
                    }
                }
            };

            ctrl.ChangeEstadoTurnosAfectados = function (estado, paso_siguiente) {
                utilsService.swalTitle('Procesando datos', 'info');
                agendaService.Tratamiento_Turnos_Req_Reag({
                    "Id_Agenda": ctrl.Agenda.Id_Agenda,
                    "Id_Estado": estado
                }).$promise.then(function (result) {
                    swal.close();
                    ctrl.continuarPasoSiguiente(paso_siguiente);
                }).catch(function (error) {
                    utilsService.errores(error, null);
                });
            }

            ctrl.controlarTurnosAfectados = function (result, paso_siguiente) {
                let opciones = [];
                if (result.Data.Estados.length > 0) {
                    for (var i = 0; i < result.Data.Estados.length; i++) {
                        var Indice = 0;
                        var valor = '';
                        angular.forEach(result.Data.Estados[i], function (value, key) {
                            if (key == 'id') {
                                Indice = value;
                            }
                            if (key == 'text') {
                                valor = value;
                            }
                        });
                        opciones[Indice] = valor;
                    }
                }

                if (result.Data && result.Data.Turnos_Reagendados && result.Data.Turnos_Reagendados != 'null') {
                    swal({
                        title: 'Turnos Afectados',
                        html: "Existen turno/s afectados al cambio realizado.<br/> Seleccione el estado al cual se deben pasar los turnos afectados: <br/> ",
                        type: 'warning',
                        input: 'select',
                        showCancelButton: false,
                        inputOptions: opciones,
                        confirmButtonColor: '#004b81',
                        cancelButtonColor: '#971b2f',
                        confirmButtonText: 'Aceptar'
                    }).then(function (input) {
                        ctrl.ChangeEstadoTurnosAfectados(input, paso_siguiente);
                    });
                } else {
                    ctrl.continuarPasoSiguiente(paso_siguiente);
                }        
            };

            ctrl.continuarPasoSiguiente = function (paso_siguiente) {
                if (paso_siguiente) {
                    ctrl.ctrlPadre.inicioAgendaPaso5(true, ctrl.Agenda.Id_Estado == TurneroAppConstant.Estados.Agenda.Pendiente, ctrl.Agenda.Id_Agenda);
                } else {
                    ctrl.cancelar(true);
                }
            };

            ctrl.validarForm = function () {
                //se limpian las variables aux de las franjas.
                ctrl.Franjas_Modificacion = '';
                ctrl.Agenda.Franjas_Alta = '';
                ctrl.Agenda.Id_Franja_Baja = '';

                ctrl.Agenda.Franjas = ctrl.Agenda.Franjas == null ? [] : ctrl.Agenda.Franjas;
                //se recorre el array de franjas
                for (var i = 0; i < ctrl.Agenda.Franjas.length; i++) {
                    //si existen franjas modificadas, se las agrega a ctrl.Franjas_Modificacion
                    if (ctrl.Agenda.Franjas[i].Id_Franja && ctrl.Agenda.Franjas[i].stringModificado != null && ctrl.Agenda.Franjas[i].stringModificado != '') {
                        ctrl.Franjas_Modificacion = ctrl.Franjas_Modificacion == '' ? ctrl.Agenda.Franjas[i].stringModificado : ctrl.Franjas_Modificacion + '|' + ctrl.Agenda.Franjas[i].stringModificado
                        //Si la franja es nueva se la agrega al ctrl.Agenda.Franjas_Alta
                    } else if (!ctrl.Agenda.Franjas[i].Id_Franja) {
                        ctrl.Agenda.Franjas_Alta = ctrl.Agenda.Franjas_Alta == '' ? ctrl.Agenda.Franjas[i].stringModificado : ctrl.Agenda.Franjas_Alta + '|' + ctrl.Agenda.Franjas[i].stringModificado

                    }

                }

                ctrl.Agenda.Franjas_Modificacion = ctrl.Franjas_Modificacion;
                ctrl.Agenda.Id_Franja_Baja = ctrl.Id_Franja_Baja; //esta infomacion se llena cuando el usuario hace click en eliminar una franja
                //se verifica que por lo menos exista una franja 
                if (ctrl.Agenda.Franjas.length == 0) {
                    swal({
                        title: 'Error',
                        text: 'La agenda debe tener al menos una franja horaria.',
                        type: 'warning',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        confirmButtonText: 'Aceptar'
                    });
                    return false;
                }

                if (ctrl.Agenda.Franjas) {
                    //Verificamos que las franjas particulares cargadas sean para una fecha futura, y dentro del rango de la fecha desde y hasta definida para la agenda.
                    for (var i = 0; i < ctrl.Agenda.Franjas.length; i++) {
                        var franja = ctrl.Agenda.Franjas[i];
                        if (franja.EsDiaParticular && moment(franja.Fecha).isValid() || moment(moment(franja.Dias_Seleccionados, 'DD/MM/YYYY').toDate()).isValid()) {
                            var fecha = franja.EsDiaParticular ? franja.Fecha : moment(moment(franja.Dias_Seleccionados, 'DD/MM/YYYY').toDate());

                            if (!fechaValidaEntreFechas(moment(fecha).format('DD/MM/YYYY'), moment(ctrl.Agenda.Fec_Desde).format('DD/MM/YYYY'), moment(ctrl.Agenda.Fec_Hasta).format('DD/MM/YYYY'))) {
                                swal({
                                    title: 'Error',
                                    text: 'La fecha particular debe estar comprendida entre la fecha de inicio y la fecha de fin de la agenda',
                                    type: 'warning',
                                    allowEscapeKey: false,
                                    allowOutsideClick: false,
                                    confirmButtonText: 'Aceptar'
                                });
                                return false;
                            }
                        }
                    }
                }
                //ejecutamos las validaciones de duracion de turno, de max turno, y de fechas en la agenda.
                if (!(ctrl.validacionesDuracionTurnos() && ctrl.validacionesMaxTurnos() && ctrl.validacionesFechaAgenda())) {
                    return false;
                }
                //Si todo salio bien retorna true, LO QUE SIGNIFICA QUE NO EXISTEN ERRORES.
                return true;
            };

            ctrl.validacionesDuracionTurnos = function () {
                //Se deben completar los campos Ciclo de turnos y Duracion de Turnos, ya que si estan vacios se generara un error.
                //Se los completa automaticamente con valores por defecto la primera vez.
                //las variables ctrl.errores.(*) son variables que se setean en true, para mostrar los mensajes de error.
                ctrl.errores.Duracion_Turno_Ciclo = false;
                if (!ctrl.Agenda.Duracion_Turno) {
                    ctrl.errores.Duracion_Turno = true;
                    return false;
                } else ctrl.errores.Duracion_Turno = false;

                if (!ctrl.Agenda.Ciclos_Turnos) {
                    ctrl.errores.Ciclos_Turnos = true;
                    return false;
                } else ctrl.errores.Ciclos_Turnos = false;

                //Si la duracion del turno es mayor al ciclo del turno, tambien habra un error.

                if (ctrl.Agenda.Duracion_Turno > ctrl.Agenda.Ciclos_Turnos) {
                    ctrl.errores.Duracion_Turno_Ciclo = true;
                    return false;
                } else ctrl.errores.Duracion_Turno_Ciclo = false;

                //Si todo salio bien retorna true, LO QUE SIGNIFICA QUE NO EXISTEN ERRORES.
                return true;
            }

            ctrl.validacionesMaxTurnos = function () {
                //Se deben completar los campos Max_Turnos_Dias_x_Online y Max_Turnos_Dias, ya que si estan vacios se generara un error.
                //Se los completa automaticamente con valores por defecto la primera vez.
                //las variables ctrl.errores.(*) son variables que se setean en true, para mostrar los mensajes de error.
                ctrl.errores.Max_Turnos_Dias_x_Online = false;
                if (!ctrl.Agenda.Max_Turnos_Dias && ctrl.Agenda.Max_Turnos_Dias != 0) {
                    ctrl.errores.Max_Turnos_Dias = true;
                    return false;
                } else ctrl.errores.Max_Turnos_Dias = false;

                if (!ctrl.Agenda.Max_Turnos_Online && ctrl.Agenda.Max_Turnos_Online != 0) {
                    ctrl.errores.Max_Turnos_Online = true;
                    return false;
                } else ctrl.errores.Max_Turnos_Online = false;

                //Si la Max_Turnos_Dias_x_Online es mayor Max_Turnos_Dias, tambien habra un error.
                if (ctrl.Agenda.Max_Turnos_Online > ctrl.Agenda.Max_Turnos_Dias) {
                    ctrl.errores.Max_Turnos_Dias_x_Online = true;
                    return false;
                } else ctrl.errores.Max_Turnos_Dias_x_Online = false;

                //Si todo salio bien retorna true, LO QUE SIGNIFICA QUE NO EXISTEN ERRORES.
                return true;
            }

            ctrl.validacionesFechaAgenda = function () {
                //Se deben completar los campos Fec_Desde y Fec_Hasta, ya que si estan vacios se generara un error.
                //Se los completa automaticamente con valores por defecto la primera vez, con la fecha del sysdate.
                //las variables ctrl.errores.(*) son variables que se setean en true, para mostrar los mensajes de error.
                ctrl.errores.Fec_Desde_Hasta = false;

                if (!ctrl.Agenda.Fec_Desde) {
                    ctrl.errores.Fec_Desde = true;
                    return false;
                } else ctrl.errores.Fec_Desde = false;

                if (!ctrl.Agenda.Fec_Hasta) {
                    ctrl.errores.Fec_Hasta = true;
                    return false;
                } else ctrl.errores.Fec_Hasta = false;
                //Si la Fec_Desde es mayor Fec_Hasta, tambien habra un error.
                if (moment(ctrl.Agenda.Fec_Desde) > moment(ctrl.Agenda.Fec_Hasta)) {
                    ctrl.errores.Fec_Desde_Hasta = true;
                    return false;
                } else ctrl.errores.Fec_Desde_Hasta = false;

                //Si todo salio bien retorna true, LO QUE SIGNIFICA QUE NO EXISTEN ERRORES.
                return true;
            }

            ctrl.getFranja = function (Id_Franja, Index) {
                //este metodo se ejecuta siempre que se este por crear una franja nueva o se este por modificar una.
                ctrl.limpiarAuxiliaresHorarios();

                if ((Id_Franja && ctrl.Agenda.Franjas[Index].index == null) || (!Id_Franja && Index === '')) {
                    agendaService.Get_Franja(({ 'id_franja': Id_Franja }), function (result) {
                        ctrl.Franja = result.Data;
                        ctrl.Franja.Cant_Puestos = ctrl.Franja.Cant_Puestos == 0 ? null : ctrl.Franja.Cant_Puestos;
                        ctrl.Franja.EsDiaParticular = ctrl.Franja.Fecha ? true : false;
                        ctrl.Franja.Fecha = ctrl.Franja.Fecha ? ctrl.Franja.Fecha : (new Date()).toISOString();
                        ctrl.Franja.Tipo_Franja_Definido = ctrl.Franja.Id_Franja == 0 ? false : true;
                        ctrl.mostrarModificarAgregar = true;
                        ctrl.index = Index;
                        ctrl.Franja.index = Index

                    }, function (error) {
                        swal.close();
                        sweetAlert("Oops...", "Ha ocurrido un error al intentar actualizar la agenda. </br> <strong>Código de error: </strong> </br>" + error.data.ExceptionMessage, "error");
                    });
                } else {
                    //si la franja esta recien creada o recien modificada (modificada sin guardar), se la obtiene por el Index
                    ctrl.Franja = ctrl.Agenda.Franjas[Index];
                    ctrl.Franja.EsDiaParticular = ctrl.Franja.Fecha ? true : false;
                    ctrl.Franja.index = Index;
                    ctrl.index = Index;
                    ctrl.mostrarModificarAgregar = true;
                }

                $timeout(function () {
                    new InputMask({
                        masked: ".masked"
                    });
                });
            };

            ctrl.agregarEditarFranja = function () {
                //la funciona ValidarFormulario, ejecuta validaciones sobre el formulario de alta/modificacion de franja
                if (ctrl.ValidarFormulario()) {
                    var diasSeleccionados = '';
                    //sobre la franja busca los dias seleccionados.
                    for (var i = 0; i < ctrl.Franja.Dias.length; i++) {
                        if (ctrl.Franja.Dias[i].Id_Seleccionado != '') {
                            diasSeleccionados = diasSeleccionados == '' ? ctrl.Franja.Dias[i].text.substring(0, 3) : diasSeleccionados + ' - ' + ctrl.Franja.Dias[i].text.substring(0, 3);
                        }
                    }
                    //genero el string auxiliar para los datos de alta de la franja.
                    //LA BASE DE DATOS RECIBE UN STRING CONCATENADO (CADA  FRANJA QUE LE SEPARA SUS PARAMETROS POR ',' (COMA))
                    var auxFranja = '';
                    auxFranja = (!ctrl.Franja.Id_Franja ? 'null' : ctrl.Franja.Id_Franja) + ',' +
                        ctrl.Franja.Hora_Desde + ',' + ctrl.Franja.Hora_Hasta + ',' + ctrl.Franja.Cant_Puestos + ',' +
                        (!ctrl.Franja.EsDiaParticular && ctrl.Franja.Dias[0].Id_Seleccionado ? 'S' : 'N') + ',' +
                        (!ctrl.Franja.EsDiaParticular && ctrl.Franja.Dias[1].Id_Seleccionado ? 'S' : 'N') + ',' +
                        (!ctrl.Franja.EsDiaParticular && ctrl.Franja.Dias[2].Id_Seleccionado ? 'S' : 'N') + ',' +
                        (!ctrl.Franja.EsDiaParticular && ctrl.Franja.Dias[3].Id_Seleccionado ? 'S' : 'N') + ',' +
                        (!ctrl.Franja.EsDiaParticular && ctrl.Franja.Dias[4].Id_Seleccionado ? 'S' : 'N') + ',' +
                        (!ctrl.Franja.EsDiaParticular && ctrl.Franja.Dias[5].Id_Seleccionado ? 'S' : 'N') + ',' +
                        (!ctrl.Franja.EsDiaParticular && ctrl.Franja.Dias[6].Id_Seleccionado ? 'S' : 'N') + ',' +
                        (ctrl.Modalidades[TurneroAppConstant.Modalidades.OnLine]) + ',' +
                        (ctrl.Modalidades[TurneroAppConstant.Modalidades.Presencial]) + ',' +
                        (ctrl.Modalidades[TurneroAppConstant.Modalidades.Orden_de_Llegada]) + ',' +
                        (ctrl.Modalidades[TurneroAppConstant.Modalidades.Atencion_Telefonica]) + ',' +
                        (!ctrl.Franja.EsDiaParticular && diasSeleccionados ? 'null' : moment(ctrl.Franja.Fecha).toDate().toLocaleDateString('es-AR'));


                    ctrl.Franja.Dias_Seleccionados = diasSeleccionados;
                    ctrl.Franja.Fecha = ctrl.Franja.Fecha;
                    ctrl.Franja.OnLine = ctrl.Modalidades[TurneroAppConstant.Modalidades.OnLine];
                    ctrl.Franja.Presencial = ctrl.Modalidades[TurneroAppConstant.Modalidades.Presencial];
                    ctrl.Franja.Orden_Llegada = ctrl.Modalidades[TurneroAppConstant.Modalidades.Orden_de_Llegada];
                    ctrl.Franja.Telefonica = ctrl.Modalidades[TurneroAppConstant.Modalidades.Atencion_Telefonica];
                    ctrl.Franja.Contador = ctrl.calcularTurnos(ctrl.Franja);
                    ctrl.Franja.Tipo_Franja_Definido = true;

                    if (ctrl.Franja.Id_Franja !== '' && ctrl.index !== "") {
                        //verifico que el objeto modificado, si fue modificado en algun momento, se lo pise.
                        //EN la propiedad STRINGMODIFICADO, se guarda las modificaciones de la franja. se pisan las modificaciones viejas
                        ctrl.Franja.stringModificado = auxFranja
                        //Se guarda la franja en la lista de franjas 
                        ctrl.Agenda.Franjas[ctrl.index] = ctrl.Franja;
                    } else {
                        //Si es un alta, se la agrega a la franja al objeto ctrl.Franjas_Alta. 
                        //LAS FRANJAS SE SEPARAN DE LAS DEMAS CON EL '|' (PIPE)
                        ctrl.Franjas_Alta = ctrl.Franjas_Alta == '' ? auxFranja : ctrl.Franjas_Alta + '|' + auxFranja
                        if (ctrl.Agenda.Franjas == null) {
                            ctrl.Agenda.Franjas = [];
                        }
                        ctrl.Franja.stringModificado = auxFranja;
                        //La agregamos a la lista de Franjas, para que se muestre en la grilla
                        ctrl.Agenda.Franjas.push(ctrl.Franja);
                    }

                    //ctrl.total();
                    ctrl.mostrarModificarAgregar = false;
                }
            };

            //retorna true, para cuando termina correctamente, sino false.
            ctrl.ValidarFormulario = function () {
                //Valido si la franja tiene datos cargados
                if (ctrl.Franja) {
                    //Valida si tiene Puestos cargados
                    if (ctrl.Franja.Cant_Puestos) {
                        //valida que se haya cargado hora desde y hora hasta, para todos los casos.
                        if (ctrl.Franja.Hora_Desde && ctrl.Franja.Hora_Hasta) {
                            if ((ctrl.Franja.Hora_Desde < ctrl.Franja.Hora_Hasta) || (ctrl.Franja.Hora_Desde === '00:00' && ctrl.Franja.Hora_Hasta == '00:00') || ctrl.Franja.Hora_Hasta == '00:00') {
                                var seleccionodias = false;
                                //busco si tiene un dia de la semana seleccionado.
                                for (var i = 0; i < ctrl.Franja.Dias.length; i++) {
                                    if (ctrl.Franja.Dias[i].Id_Seleccionado != '') {
                                        seleccionodias = true;
                                    }
                                }
                                //Valido si (es fecha particular y tiene una fecha cargada) o (si no es fecha particular y tiene al menos un dia de la semana seleccionado)
                                if ((ctrl.Franja.EsDiaParticular && ctrl.Franja.Fecha) || (!ctrl.Franja.EsDiaParticular && seleccionodias)) {
                                    var seleccionoModalidad = false;
                                    var esOrdenDeLlegada = false;
                                    var count = 0;
                                    ctrl.Modalidades = [];
                                    //verifico si selecciono modalidad
                                    for (var i = 0; i < ctrl.Franja.Modalidades.length; i++) {
                                        if (ctrl.Franja.Modalidades[i].Id_Seleccionado != '') {
                                            count = count + 1;
                                            seleccionoModalidad = true;
                                            if (ctrl.Franja.Modalidades[i].id == TurneroAppConstant.Modalidades.Orden_de_Llegada) {
                                                esOrdenDeLlegada = true;
                                            }
                                        }
                                        ctrl.Modalidades[ctrl.Franja.Modalidades[i].id] = ctrl.Franja.Modalidades[i].Id_Seleccionado ? 'S' : 'N';
                                    }
                                    if (seleccionoModalidad) {
                                        if (ctrl.Agenda.EsSUAC && esOrdenDeLlegada && count == 1 || !ctrl.Agenda.EsSUAC) {
                                            //todas las validaciones fueron correctas.
                                            return true;
                                        } else {
                                            sweetAlert("Datos Requeridos!", "Su agenda es SIN TRÁMITE. </br> Las agendas SIN TRÁMITES solo admiten la modalidad : 'Orden de llegada'. </br> Por favor verifique que la misma este seleccionada.", "warning");
                                            return false;
                                        }

                                    } else {
                                        sweetAlert("Datos Requeridos!", "Debe seleccionar al menos 1 (una) modalidad para esta agenda, por favor complételos.", "warning");
                                        return false;
                                    }
                                } else {
                                    sweetAlert("Datos Requeridos!", "El campo " + (ctrl.Franja.EsDiaParticular ? "Fecha" : "Dias") + " es requerido, por favor complételo.", "warning");
                                    return false;
                                }
                            } else {
                                sweetAlert("Error en los datos", "La hora desde debe ser menor a la hora hasta. Verifíquelos y vuelva a intentarlo", "warning");
                                return false;
                            }
                        } else {
                            sweetAlert("Datos Requeridos!", "Los campos hora desde y la hora hasta son requeridos, por favor complételos.", "warning");
                            return false;
                        }
                    } else {
                        sweetAlert("Datos Requeridos", "El campo cantidad de puestos es requerido, por favor complételo.", "warning");
                        return false;
                    }
                }
            };

            ctrl.calcularTurnos = function (franja) {
                //Esta funcion realiza los calculos de cantidad de turnos por franja
                var hd = franja.Hora_Desde;
                var hh = franja.Hora_Hasta;

                var ahd = hd.split(':');
                var dated = "";
                var hora_desde = "";

                var ahh = hh.split(':');
                var dateh = "";
                var hora_hasta = "";

                if ((hd == '00:00' && hh == '00:00') || (hd > hh)) {

                    dated = new Date(2011, 1, 1, (+ahd[0]), (+ahd[1]));
                    hora_desde = dated;

                    dateh = new Date(2011, 1, 2, (+ahh[0]), (+ahh[1]));
                    hora_hasta = dateh;

                } else {

                    dated = new Date(2011, 1, 1, (+ahd[0]), (+ahd[1]));
                    hora_desde = dated;

                    dateh = new Date(2011, 1, 1, (+ahh[0]), (+ahh[1]));
                    hora_hasta = dateh;
                }

                var diffMs = (hora_hasta - hora_desde);
                var minutes = Math.floor((diffMs / 1000) / 60);

                return Math.floor(minutes / ctrl.Agenda.Ciclos_Turnos) * franja.Cant_Puestos;
            };

            //ctrl.total = function () {
            //	//retorna la cantidad total de turnos para todas las franjas
            //	var count = 0;
            //	if (ctrl.Agenda.Franjas) {
            //		for (var i = 0; i < ctrl.Agenda.Franjas.length; i++) {
            //			count = ctrl.Agenda.Franjas[i].Contador + count;
            //		}
            //	}
            //	ctrl.CantidadTurnos = count;
            //};

            ctrl.limpiarAuxiliaresHorarios = function () {
                ctrl.Modalidades = [];
                ctrl.index = null;

                ctrl.Franja = {
                    Id_Franja: 0,
                    Hora_Desde: '',
                    Hora_Hasta: '',
                    Cant_Puestos: 0,
                    Id_Franja_Particular: 0,
                    Fecha: moment(moment().toDate().toLocaleString()).format('DD-MM-YYYY'),
                    Dias: '',
                    Modalidades: ''
                };
            }

            ctrl.cancelarFranja = function () {
                //cierra el formulario de alta/modificaciones de franjas
                ctrl.limpiarAuxiliaresHorarios();
                ctrl.mostrarModificarAgregar = false;
                //ctrl.total();
            };

            ctrl.eliminarItem = function (franja) {
                swal({
                    //title: 'Eliminar Franja Horaria',
                    html: '¿Desea eliminar la franja horaria?',
                    type: 'info',
                    showCancelButton: true,
                    //confirmButtonColor: 'rgb(48, 133, 214)',
                    cancelButtonColor: '#971b2f',
                    confirmButtonText: "Aceptar",
                    cancelButtonText: "Cancelar",
                    allowEscapeKey: false,
                    allowOutsideClick: false
                }).then(function () {
                    //Metodo para eliminar franjass
                    for (var i = 0; i < ctrl.Agenda.Franjas.length; i++) {
                        if (franja == ctrl.Agenda.Franjas[i]) {
                            //Eliminamos del array de franjas (Grilla)
                            ctrl.Agenda.Franjas.splice(i, 1);
                            if (franja.Id_Franja) {
                                //si la franja existia en la base de datos, tiene Id_Franja, entonces se la agrega a la lista de franjas bajas
                                //EN ESTE CASO ES UNA CONCATENACION DE ID_FRANJA, SEPARADO POR ',' (COMA)
                                ctrl.Id_Franja_Baja = ctrl.Id_Franja_Baja == '' ? franja.Id_Franja : ctrl.Id_Franja_Baja + ',' + franja.Id_Franja
                            }
                        }
                    };
                    //ctrl.total();
                }, function (err) {
                    swal.close();
                });
            };

            ctrl.cambiarFechaParticular = function () {
                ctrl.Franja.Fecha = ctrl.Franja.EsDiaParticular ? (new Date()).toISOString() : null
            }

            ctrl.recalcularContadores = function () {
                if (ctrl.Agenda.Franjas) {
                    for (var i = 0; i < ctrl.Agenda.Franjas.length; i++) {
                        ctrl.Agenda.Franjas[i].Contador = ctrl.calcularTurnos(ctrl.Agenda.Franjas[i]);
                    }
                }
                //ctrl.total();
            }

            ctrl.validarFormulario = function () {
                //esta funcion es llamada desde el html para validar si habilitar o no el boton. para agregar una franja
                if (ctrl.Agenda && ctrl.Agenda.Fec_Desde && ctrl.Agenda.Fec_Hasta && ctrl.Agenda.Duracion_Turno && ctrl.Agenda.Ciclos_Turnos) {
                    return true;
                }
                return false;

            }

            function exportarExcel(data) {
                //En este metodo se exportan los tramites repetidos a excel
                var arrayObject = data;
                ctrl.arrayExport = [];
                //TITULOS
                ctrl.arrayExport[1] = ['Número y Nombre de Tramite', 'Número y Nombre de Agenda'];
                //TODAS LAS FILAS.
                for (var i = 0; i < arrayObject.length; i++) {
                    var index = ctrl.arrayExport.length;
                    ctrl.arrayExport[ctrl.arrayExport.length] = [arrayObject[i].Tramite, arrayObject[i].Agendas[0]];
                    for (var j = 1; j < arrayObject[i].Agendas.length; j++) {
                        ctrl.arrayExport[ctrl.arrayExport.length] = [' ', arrayObject[i].Agendas[j]];
                    }

                }
                swal.close();
                //se envian los datos para descargar el excel
                ctrl.Excel.down([{
                    name: 'Tramites_Repetidos',
                    data: ctrl.arrayExport
                }]);

            }

            function fechaValidaEntreFechas(fecha, fechaDesde, fechaHasta) {
                var d1 = fechaDesde.split("/");
                var d2 = fechaHasta.split("/");
                var c = fecha.split("/");

                // -1 because months are from 0 to 11
                var from = new Date(d1[2], parseInt(d1[1]) - 1, d1[0]);
                var to = new Date(d2[2], parseInt(d2[1]) - 1, d2[0]);
                var check = new Date(c[2], parseInt(c[1]) - 1, c[0]);

                return check >= from && check <= to;
            }

            ctrl.Excel = {
                down: function () {
                },
            }
        }
    ],
    template: require('./agenda_Paso4.html')
});



// WEBPACK FOOTER //
// ./app/components/agenda/agenda_Paso4Component.js